export enum PriceCutType {
  Percentage = 1,
  Value = 2,
}
